import Api from './Api'
import LocalStorage from './LocalStorageService'

class ClientService {
  about () {
    return Api().get('client/about')
  }

  insert (item) {
    return Api().post('client', item)
  }

  update (item) {
    return Api().put('client', item)
  }

  findAll (accessUrl = LocalStorage.getAccessUrl(), clientPrefix = LocalStorage.getClientPrefix()) {
    return Api(accessUrl).get(`${clientPrefix}/client`)
  }

  delete ({ urlPrefix }) {
    return Api().delete(`${`${LocalStorage.getClientPrefix()}/client`}/${urlPrefix}`)
  }

  findById (id) {
    const url = `${LocalStorage.getClientPrefix()}/client/${id}`
    return Api().get(url)
  }
}

export default new ClientService()
